import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin.service';

import { Global } from '../../../app.global';
import { SettingsService } from '../../../authentication/services/settings.service';
import { HelperService } from '../../../shared/common/services/helper.service';
import { flashAnimation } from '../../../app.animations';
import { GlobalObservables } from '../../../app.global.observer';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  animations: [flashAnimation],
})
export class ConfigurationComponent implements OnInit {
  systemInfo = [];
  snippetCodeId = 'snippet-code-id';
  isCopyLabelShown = false;
  // enableDebugConsole = false;

  constructor(
    private adminService: AdminService,
    public global: Global,
    private globalObs: GlobalObservables,
    private settingsService: SettingsService,
    private helpService: HelperService
  ) {}

  ngOnInit() {
    // console.log(this.global.appSettings);
    this.getSystemInformation();
  }

  getSystemInformation() {
    this.systemInfo = [];
    this.adminService.getSystemInformation().subscribe((info) => {
      if (info) {
        this.systemInfo = Object.entries(info);
        // this.enableDebugConsole = info['enableDebugConsole'].toLowerCase() === 'true';
        // this.enableDebugConsole = this.settingsService.getLocalDebugConsole() === 'true';
      }
    });
  }

  // switchDebugConsole() {
  //   this.adminService.switchDebugConsole(!this.enableDebugConsole).subscribe((result) => {
  //     if (result) {
  //       this.enableDebugConsole = !this.enableDebugConsole;
  //       // this.global.appSettings['Configuration.EnableDebugConsole'] = this.enableDebugConsole;
  //       this.settingsService.updateEnableDebugConsole(this.enableDebugConsole);
  //     } else {
  //       this.globalObs.pushError.next({
  //         status: 200,
  //         statusText: 'Success',
  //         message: "Can't enable debug console",
  //         url: '',
  //         date: new Date(),
  //       });
  //     }
  //   });
  // }

  copyToClipboard(value) {
    const snippetCodeEl = document.getElementById(this.snippetCodeId) as HTMLInputElement;
    snippetCodeEl.value = value;
    snippetCodeEl.select();
    document.execCommand('copy');
    this.isCopyLabelShown = true;
    setTimeout(() => {
      this.isCopyLabelShown = false;
    }, 1500);
  }
}
